import React from 'react';
import { Formik } from 'formik';
import { Pad } from 'components/Pad/Pad';
import '../AuthPages.scss';
import { useLoginPageVM } from './useLoginPageVM';
import VerificationInput from 'react-verification-input';
import logo from 'assets/images/logo-colored.svg';
import { Button } from 'components/Button/Button';
import { isMobile } from 'react-device-detect';
import { Loader } from 'components/Loader/Loader';

interface LoginFormValues {
    email: string;
    password: string;
}

export const LoginPage: React.FC = () => {
    const {
        emailAuthLogin,
        phoneValue,
        setPhoneValue,
        isComplete,
        isAppv,
        setIsAppv,
        inputRef,
        handleNumberClick,
        handleDelete,
        handleSubmit,
        phoneAuthStep,
        codeValue,
        setCodeValue,
        emailAuthErrorMessage,
        phoneAuthErrorMessage,
        handleForgotPassword,
        phoneAuthLoginLoading,
        isRoleChoice,
        setIsRoleChoice
    } = useLoginPageVM();

    return (
        <div id="login">
            <div className="login-wrapper">
                <img src={logo} className="logo" alt="Logo" />
                <div className={`login-form-wrapper ${isRoleChoice ? 'role-choice' : ''}`}>
                    <div className="login-form">
                        {!isRoleChoice ? (
                            <>
                                <h1>Vous avez un projet de vie ?</h1>
                                <Button
                                    label="Cliquez ici"
                                    variant="dark"
                                    callback={() => {
                                        setIsRoleChoice(true);
                                        setIsAppv(false);
                                    }}
                                />
                            </>
                        ) : !isAppv ? (
                            phoneAuthStep === 'phone' ? (
                                <>
                                    <h1>Entrez ici votre numéro de téléphone</h1>
                                    <VerificationInput
                                        ref={inputRef}
                                        value={phoneValue}
                                        onChange={setPhoneValue}
                                        autoFocus
                                        validChars="0-9"
                                        length={10}
                                        placeholder="_"
                                        classNames={{
                                            container: 'container',
                                            character: 'character',
                                            characterInactive: 'character--inactive',
                                            characterSelected: 'character--selected'
                                        }}
                                    />
                                    {phoneAuthErrorMessage && <p className="api-error">Numéro de téléphone non reconnu</p>}
                                    {phoneAuthLoginLoading ? (
                                        <Loader />
                                    ) : (
                                        <Pad onNumberClick={handleNumberClick} onDelete={handleDelete} listenToKeyboard={true} />
                                    )}
                                    {isComplete && !phoneAuthLoginLoading && (
                                        <Button label="Valider" variant="dark" callback={handleSubmit} isUser />
                                    )}
                                </>
                            ) : (
                                <>
                                    <h1>Entrez ici le code de vérification reçu par SMS au {phoneValue}</h1>
                                    <p>Attention, le code expire dans 30 minutes.</p>
                                    <VerificationInput
                                        ref={inputRef}
                                        value={codeValue}
                                        onChange={setCodeValue}
                                        autoFocus
                                        validChars="0-9"
                                        length={4}
                                        placeholder="_"
                                        classNames={{
                                            container: 'container',
                                            character: 'character',
                                            characterInactive: 'character--inactive',
                                            characterSelected: 'character--selected'
                                        }}
                                    />
                                    <Pad onNumberClick={handleNumberClick} onDelete={handleDelete} listenToKeyboard={true} />
                                    {isComplete && <Button label="Valider" variant="dark" callback={handleSubmit} isUser />}
                                </>
                            )
                        ) : (
                            <>
                                <Formik<LoginFormValues>
                                    initialValues={{
                                        email: '',
                                        password: ''
                                    }}
                                    onSubmit={async (
                                        values: LoginFormValues,
                                        { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }
                                    ) => {
                                        const { email, password } = values;
                                        await emailAuthLogin({
                                            email,
                                            password
                                        });
                                        setSubmitting(false);
                                    }}
                                >
                                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                                        <form onSubmit={handleSubmit} className="form admin-form">
                                            <h1>Connectez-vous à votre compte administrateur</h1>
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Adresse e-mail"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.email}
                                                required
                                            />
                                            {errors.email && touched.email && errors.email}
                                            <input
                                                type="password"
                                                name="password"
                                                placeholder="Mot de passe"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.password}
                                                required
                                            />
                                            {errors.password && touched.password && errors.password}
                                            {emailAuthErrorMessage && <p className="api-error">Nom d'utilisateur ou mot de passe erroné</p>}
                                            <Button label="Se connecter" variant="dark" type="submit" disabled={isSubmitting} />
                                            <span onClick={handleForgotPassword}>Mot de passe oublié ?</span>
                                        </form>
                                    )}
                                </Formik>
                            </>
                        )}
                    </div>
                    {isRoleChoice && (
                        <p>
                            <span onClick={() => setIsRoleChoice(false)}>Retour</span>
                        </p>
                    )}
                    {!isRoleChoice && (
                        <div className="login-form">
                            <h1>Vous êtes un professionnel du DAPV ?</h1>
                            <Button
                                label="Cliquez ici"
                                variant="dark"
                                callback={() => {
                                    setIsRoleChoice(true);
                                    setIsAppv(true);
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
